<script>
  import Button from './button.svelte';

  import { createEventDispatcher } from 'svelte';

  import { faCamera, faMicrophone, faDesktop } from '@fortawesome/free-solid-svg-icons';

  export let sharingVideo;
  export let sharingVideoLoading;
  export let sharingAudio;
  export let sharingAudioLoading;
  export let sharingScreen;
  export let sharingScreenLoading;

  const dispatch = createEventDispatcher();

  function clickOnQuit() {
    dispatch('quitClick');
  }

  function clickOnMic() {
    sharingAudio = !sharingAudio;
    dispatch('micClick');
  }
  function clickOnCamera() {
    sharingVideo = !sharingVideo;
    dispatch('cameraClick');
  }
  function clickOnScreen() {
    sharingScreen = !sharingScreen;
    dispatch('screenClick');
  }
</script>

<div class="wrapper">
  <div class="action-group">
    <Button
      type="secondary"
      icon={faMicrophone}
      label=""
      isLoading={sharingAudioLoading}
      iconMarginRight="19px"
      iconMarginLeft="19px"
      on:click={clickOnMic}
      selected={sharingAudio}
    />
    <Button
      type="secondary"
      icon={faCamera}
      label=""
      isLoading={sharingVideoLoading}
      iconMarginRight="17px"
      iconMarginLeft="17px"
      on:click={clickOnCamera}
      selected={sharingVideo}
    />
    <Button
      type="secondary"
      icon={faDesktop}
      label=""
      isLoading={sharingScreenLoading}
      iconMarginRight="16px"
      iconMarginLeft="16px"
      on:click={clickOnScreen}
      selected={sharingScreen}
    />
  </div>
  <div class="button">
    <Button label="Quit room" on:click={clickOnQuit} />
  </div>
</div>

<style>
  .wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    background: #161e2f;
    width: 100%;
    height: 100px;
  }
  .action-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
  }
  .button {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    right: 20px;
    top: 0;
    bottom: 0;
    width: 200px;
  }
</style>
